var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleBroker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.774 18.5C21.5233 18.5 22.1192 18.0285 22.6544 17.3691C23.7498 16.0194 21.9512 14.9408 21.2653 14.4126C20.5679 13.8756 19.7893 13.5714 18.9999 13.5M17.9999 11.5C19.3806 11.5 20.4999 10.3807 20.4999 9C20.4999 7.61929 19.3806 6.5 17.9999 6.5",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.22588 18.5C2.47658 18.5 1.88059 18.0285 1.34547 17.3691C0.250012 16.0194 2.04859 14.9408 2.73457 14.4126C3.4319 13.8756 4.21051 13.5714 4.99992 13.5M5.49992 11.5C4.11921 11.5 2.99992 10.3807 2.99992 9C2.99992 7.61929 4.11921 6.5 5.49992 6.5",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0837 15.6112C7.06192 16.243 4.38288 17.5331 6.01459 19.1474C6.81167 19.936 7.69941 20.5 8.81552 20.5H15.1843C16.3004 20.5 17.1881 19.936 17.9852 19.1474C19.6169 17.5331 16.9379 16.243 15.9161 15.6112C13.52 14.1296 10.4798 14.1296 8.0837 15.6112Z",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4999 8C15.4999 9.933 13.9329 11.5 11.9999 11.5C10.0669 11.5 8.49989 9.933 8.49989 8C8.49989 6.067 10.0669 4.5 11.9999 4.5C13.9329 4.5 15.4999 6.067 15.4999 8Z",
    stroke: "#141B34",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleBroker);
export default __webpack_public_path__ + "static/media/ToggleBroker.2df423e2fa018de516af91d885e79ae7.svg";
export { ForwardRef as ReactComponent };